import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';

import { container } from '@Container';
import { ArmyListUnitAction } from '@Redux/actions';
import { TYPES } from '@Types';
import { ArmyListUnitView } from '@Selectors/builder/myArmyList/make/view/ArmyListUnitView';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import armyListUnitSlice from '@Redux/reducers/builder/armyListUnit.slice';

interface IArmyListUnitCloneProps {
  armyListUnit: ArmyListUnitView;
}

const ArmyListUnitClone: React.FC<ArmyListUnitCloneProps> = ({ armyListUnit, cancel, toClone }) => {

  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage {...defaultMessages.armyListUnitCloneFormTitle} /></h1>
      <p><FormattedMessage {...defaultMessages.armyListUnitCloneFormAction} /> <strong>{armyListUnit.name}</strong> ?</p>
      <div className="action">
        <button className="btn btn-age" type="button" onClick={() => cancel()}><FormattedMessage {...defaultMessages.formCancel} /></button>
        <button className="btn btn-age" type="button" onClick={() => toClone(armyListUnit)}>
          <i className="fa fa-clone" aria-hidden="true" /> <FormattedMessage {...defaultMessages.formClone} />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListUnitCloneProps) => ({
  armyListUnit: owsProps.armyListUnit
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArmyListUnitAction>(TYPES.Actions.ArmyListUnitAction);
  return {
    toClone: (armyListUnit: ArmyListUnitView) => dispatch(armyListUnitAction.actionCloneArmyListUnit(armyListUnit.id!)),
    cancel: () => dispatch(armyListUnitSlice.actions.cancel())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitClone);

type ArmyListUnitCloneProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
